import clsx from 'clsx'
import React, { ButtonHTMLAttributes } from 'react'

import Text from '@/components-latest/primitives/Text'

import Styles from './OptionButton.module.scss'

type Props = {
  icon?: React.ReactNode
  children?: React.ReactNode
  label?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

const OptionButton = React.memo(
  React.forwardRef<HTMLButtonElement, Props>(
    ({ icon, children, label, className, ...rest }, ref) => {
      return (
        <button className={clsx(Styles.button, className)} {...rest} ref={ref}>
          {icon}
          {children ? (
            children
          ) : (
            <Text asChild>
              <p>{label}</p>
            </Text>
          )}
        </button>
      )
    }
  )
)
OptionButton.displayName = 'OptionButton'
export default OptionButton
